import BaseFormItem from "../BaseFormItem";
import React from "react";
import Control from "lib/common/descriptorcontrols/TimeField/spinner";

export class TimeFieldspinner extends BaseFormItem {
    render() {
        const {activeRecord, descriptor} = this.props;
        return <Control {...this.getPlumbingProps()}
                        value={activeRecord.get(descriptor.key)}
                        enabled={activeRecord.isFieldEnabled(descriptor.key)}
        />;
    }
}

export default TimeFieldspinner;



// WEBPACK FOOTER //
// ./app/lib/dataentry/lib/dataentryform/formitems/TimeField/spinner.js